var exports = {
  "Y": "xa15a2ab7--d1a71e--special-promo",
  "w": "xa15a2ab7--d1a71e--logo",
};

module.exports = exports;
